import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from '../containers/Home';
import LemMS from '../containers/LemMS/index';
import LemU from '../containers/LemU/index';
import Repositorio from '../containers/Repositorio';
import Contacto from '../containers/Contacto';
import Perfiles from '../containers/Perfiles';
import routes from './routes';

export default function Router(props) {
  return (
    <Routes>
      <Route exact path={routes.root} element={<Home />} />
      <Route exact path={routes.lemMS} element={<LemMS />} />
      <Route exact path={routes.lemU} element={<LemU />} />
      <Route exact path={routes.repositorio} element={<Repositorio />} />
      <Route exact path={routes.contacto} element={<Contacto />} />
      <Route exact path={routes.perfiles} element={<Perfiles />} />
      {/* Puedes agregar más rutas aquí */}
    </Routes>
  );
}
